"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONSTS = void 0;
const CONSTS = exports.CONSTS = Object.freeze({
  // アクション名のプロジェクト共通接頭辞
  COMMON_ACTION_PREFIX: 'masterdata',
  DISASTER: {
    TDFK_REQUIRED: 'tdfkRequired',
    TDFK_DUPLICATE_LV1: 'tdfkDuplicateLv1',
    TDFK_DUPLICATE_LV2: 'tdfkDuplicateLv2',
    TDFK_DUPLICATE_LV3: 'tdfkDuplicateLv3'
  },
  // 子画面表示時の共通key
  COMMON_SUBWINDOW_PREFIX: 'masterdata'
});